import { coalColor } from "../../../styles/theme";
import { IconProps } from "./";

export const RestoreIcon = ({
  className,
  size = 24,
  color = coalColor,
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.06152 17.2237C5.45874 21.0426 6.48039 22.4911 8.20868 24.2504C9.93696 26.0098 12.1451 26.6103 14.5913 26.9249C17.0376 27.2396 19.2918 25.5418 22.0417 24.167C24.7917 22.7922 25.5 21.5 26.2665 19.9512C27.0331 18.4024 27.5 17.5 26.5014 12.7602C25.5029 8.02047 19 5.50001 15.3062 5.03963C11.6125 4.57926 7.6 8.2 6 11M6 11C6.33333 9.66667 6.8 6.4 6 4M6 11C7.83333 11.1667 11.6 11.4 12 11"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
